const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSustainability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M61.0577 60.0076C60.8829 60.0076 60.7082 59.9455 60.5694 59.8214C60.2672 59.5519 60.2395 59.0864 60.5106 58.7843L72.1536 45.7302C75.6143 41.8497 75.335 35.8086 71.5297 32.2645L44.3469 6.94358C40.6755 3.52368 34.9152 3.51388 31.2307 6.92235C23.7328 13.8601 16.6006 26.1532 25.2092 45.3121C25.3757 45.6829 25.2108 46.1173 24.8401 46.2839C24.471 46.4504 24.0349 46.2855 23.8683 45.9148C19.7984 36.8571 18.794 28.4037 20.8812 20.7865C22.4164 15.1912 25.5619 10.1626 30.2312 5.84281C32.2923 3.93688 34.9708 2.88672 37.7766 2.88672C37.7831 2.88672 37.788 2.88672 37.7945 2.88672C40.6069 2.89162 43.2902 3.94993 45.348 5.86729L72.5308 31.1883C74.6687 33.1792 75.9197 35.8837 76.0553 38.8022C76.1908 41.7207 75.1946 44.5282 73.2495 46.7085L61.6064 59.7626C61.4611 59.9243 61.2602 60.0076 61.0577 60.0076Z",
    fill: "#231F20",
    stroke: "#1D313D",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4401 58.4821C21.2948 58.4821 15.4823 53.2118 13.297 47.3079C10.4422 39.5927 13.493 31.0266 20.2414 27.8043C20.341 27.7569 20.4488 27.7324 20.5582 27.7324C27.1008 27.7324 31.45 29.7886 33.854 34.0186C35.9037 37.623 36.178 42.2025 36.4197 46.2414C36.7856 52.3495 37.1775 55.7955 41.0907 55.611C41.4647 55.5979 41.7929 55.8609 41.8517 56.2316C41.9105 56.6023 41.6786 56.9567 41.3177 57.0547C37.6544 58.0428 34.3668 58.4821 31.4401 58.4821ZM20.7264 29.2039C14.7604 32.1567 12.1032 39.8458 14.6755 46.7983C16.6745 52.1992 22.0509 57.0041 31.4842 57.0041C33.462 57.0041 35.6195 56.7934 37.9615 56.3312C37.1253 55.7808 36.4867 54.9283 36.0359 53.7655C35.2798 51.8138 35.1197 49.1501 34.9515 46.3296C34.4746 38.3351 33.9324 29.2791 20.7264 29.2039Z",
    fill: "#231F20",
    stroke: "#1D313D",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5967 77.1139C41.5314 77.1139 41.466 77.1139 41.3991 77.1123C38.5867 77.0633 35.9214 75.9625 33.8946 74.0125L7.11841 48.262C5.01323 46.2368 3.80468 43.5143 3.71648 40.5941C3.62829 37.674 4.66863 34.8829 6.64805 32.7336L18.4969 19.8657C18.7712 19.5668 19.2367 19.5489 19.5356 19.8232C19.8344 20.0976 19.854 20.5631 19.578 20.8619L7.72922 33.7298C4.20643 37.5548 4.38935 43.5992 8.13752 47.2037L34.9137 72.9542C38.5296 76.4312 44.2898 76.5325 48.0282 73.1845C55.6356 66.3659 62.9621 54.1888 54.6606 34.8943C54.5005 34.522 54.672 34.0891 55.0444 33.9291C55.4168 33.769 55.8495 33.9405 56.0096 34.3145C59.9341 43.4359 60.8046 51.9056 58.5949 59.4869C56.9716 65.0577 53.746 70.034 49.0081 74.2803C46.9633 76.1095 44.3372 77.1139 41.5967 77.1139Z",
    fill: "#231F20",
    stroke: "#1D313D",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0424 52.5421C59.0392 52.5421 59.0343 52.5421 59.031 52.5421C52.4884 52.4376 48.1736 50.3128 45.8365 46.0453C43.8456 42.4082 43.6431 37.8254 43.4667 33.7833C43.1989 27.6703 42.8591 24.216 38.9444 24.3418C38.5704 24.3516 38.2454 24.0805 38.1931 23.7098C38.1409 23.339 38.3777 22.9863 38.7402 22.8948C55.175 18.74 63.9093 25.436 66.6025 33.0859C69.3348 40.8452 66.1468 49.3623 59.3478 52.4751C59.2515 52.5192 59.147 52.5421 59.0424 52.5421ZM42.0834 23.6706C42.9114 24.234 43.5353 25.0963 43.9681 26.2657C44.6932 28.2288 44.8108 30.8958 44.9349 33.718C45.2861 41.719 45.6846 50.7832 58.8857 51.069C64.8974 48.2125 67.6771 40.5643 65.2159 33.5726C62.9033 27.0023 55.634 21.2241 42.0834 23.6706Z",
    fill: "#231F20",
    stroke: "#1D313D",
    style: {
      fill: "#231F20",
      fill: "color(display-p3 0.1373 0.1216 0.1255)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSustainability);
export default __webpack_public_path__ + "static/media/icon-sustainability.995466fac89a21ddadd925023338deb4.svg";
export { ForwardRef as ReactComponent };